import React from 'react';
import { useSelector } from 'react-redux';
import { ReduxStates } from '../../redux/reduxTypes';

const NoAccess = (): React.ReactElement | null => {
  const copyData = useSelector((state: ReduxStates) => state.copyData);

  return (
    <div className="relative pt-[30px] pb-[100px] px-6">
      <div className="block">
        <div className="relative border-t-4 bg-white shadow-cardShadow rounded w-full max-w-full box-border px-6 pt-[15px] pb-8 mb-8 min-h-[150px] border-navy text-center">
          <p className="mt-4 p-0 text-base font-nunitoMedium">{copyData?.no_access_title}</p>
          <p className="text-sm">{copyData?.no_access_info}</p>
        </div>
      </div>
    </div>
  );
};

export default NoAccess;
